import React, { Fragment } from 'react'

import { Pagination } from '@uswitch/spark.pagination'
import { Helmet } from 'react-helmet-async'
import { useDataSelector, useComponentMeta } from '../helpers/selectors'

const numberToLink =
  ({ pathname }) =>
  (number) =>
    number === 1 ? `${pathname}` : `${pathname}?page=${number}`

const PaginationWrapped = (props) => {
  const { total, page, limit } = props

  const meta = useComponentMeta('pagination')

  const totalPages = Math.ceil(total / limit)
  const showFirstAndLastArrows = meta?.showFirstAndLastArrows ? meta.showFirstAndLastArrows : false

  return (
    <Fragment>
      <If condition={total > limit}>
        <Helmet>
          <If condition={page > 1}>
            <link rel='prev' href={`${numberToLink(props)(page - 1)}`} />
            <link rel='first' href={`${numberToLink(props)(1)}`} />
          </If>
          <If condition={page < totalPages}>
            <link rel='next' href={`${numberToLink(props)(page + 1)}`} />
            <link rel='last' href={`${numberToLink(props)(totalPages)}`} />
          </If>
        </Helmet>
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          createPageUrl={numberToLink(props)}
          showFirstAndLastArrows={showFirstAndLastArrows}
        />
      </If>
    </Fragment>
  )
}

const PaginationConnected = (props) => {
  const paginationLimit = useDataSelector(['meta', 'paginationLimit'], 12)
  const location = useDataSelector(['location'])

  const propsConnected = {
    limit: props.limit || paginationLimit,
    page: Number(location?.query?.page) || 1,
    pathname: location?.pathname || '',
    origin: location?.origin || '',
  }

  return <PaginationWrapped {...props} {...propsConnected} />
}

export default PaginationConnected
